import { render } from "./IconHeaderCoupon.vue?vue&type=template&id=3aeb882d&scoped=true"
const script = {}

import "./IconHeaderCoupon.vue?vue&type=style&index=0&id=3aeb882d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aeb882d"]])

export default __exports__